import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Image from "antd/lib/image";
import Tooltip from "antd/lib/tooltip";
import StackGrid from "react-stack-grid";
import Profile from "../../assets/Profile_Pic.svg";
import Default_Brand from "../../assets/brandLogos/Default_Brand.svg";
import verified from "../../assets/verified.svg";
import FollowersBlue from "../../assets/FollowersBlue.svg";
import FollowingBlue from "../../assets/deepDive/FollowingBlue.svg";
import somethingWentWrong from "../../assets/No_Data_Found.svg";

import isEqual from "react-fast-compare";
import SortBy from "./SortBy";
import PaginationComponent from "./PaginationComponent";
import { SocialMedialogo } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import PillContainer from "../WidgetMaker/AuthorPills";
import { getTextDirection, kFormatter } from "../../redux/constants";

const AuthorCard = ({
  data,
  totalPageNo,
  metadata,
  section_index,
  widget_index,
  deepDive,
  mentionPage,
  pagination,
  isPreviewState,
  dashboard,
  PdfDownloadStatus,
  PptGeneratingStatus,
  noteExist,
  chart_type,
}) => {
  const grid = useRef(null);
  const [windowSize, setwindowSize] = useState(window.innerWidth);
  const isshowSideBar = useSelector((state) => state.WidgetMaker.isshowSideBar);
  let currentPath = window.location.pathname;
  let splitPath = currentPath.split("/");
  const width = windowSize;
  const updateSize = () => {
    setwindowSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", updateSize);
    // updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const resizeGrid = () => {
    let timer1 = null;
    let timer2 = null;
    if (grid && grid?.current) {
      timer1 = setTimeout(() => {
        grid?.current?.updateLayout();
      }, 500);
    }
    if (data?.length > 0) {
      timer2 = setTimeout(() => {
        grid && grid?.current?.updateLayout();
      }, 5000);
    }
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  };

  useEffect(resizeGrid, [
    width,
    isshowSideBar,
    dashboard,
    PdfDownloadStatus,
    PptGeneratingStatus,
  ]);

  const hendleClick = (e) => {
    resizeGrid();
  };

  return (
    <>
      {splitPath[1] === "widgetMaker" ||
      splitPath[1] === "edit-widget" ||
      deepDive ? (
        <div
          id={`post_card_${section_index ? section_index : "section_index"}_${
            widget_index ? widget_index : "widget_index"
          }`}
          className={`w-100 wm-chart-cards text-right`}
        >
          <SortBy
            metadata={metadata}
            section_index={section_index}
            widget_index={widget_index}
            isPreviewState={isPreviewState}
            PdfDownloadStatus={PdfDownloadStatus}
            PptGeneratingStatus={PptGeneratingStatus}
            chart_type={chart_type}
            dashboard={dashboard}
            deepDive={deepDive}
            widget_id={"1.1"}
          />
        </div>
      ) : (
        <></>
      )}
      {data?.length > 0 ? (
        <div className="row mr-0 pl-15 pr-15">
          {/* <StackGrid
            gridRef={(r) => (grid.current = r)}
            columnWidth={
              isshowSideBar || mentionPage || dashboard
                ? "33%"
                : width <= 1280
                ? "50%"
                : width <= 768
                ? "100%"
                : "33%"
            }
            style={{
              zIndex: 0,
              margin: "0 0.5rem 0.5rem 1.5rem",
              // margin:
              //   PdfDownloadStatus || PptGeneratingStatus
              //     ? "1.5rem 0.5rem 1.5rem 1.5rem"
              //     : "",
            }}
          > */}
          {data?.map((el, i) => {
            let textDirection = getTextDirection(el?.AuthorBio || "");
            let textDirectionClass =
              textDirection === "rtl" ? "text-right-arabic" : "";
            if (
              (PdfDownloadStatus || PptGeneratingStatus) &&
              noteExist &&
              i > 5
            )
              return null;
            if ((PdfDownloadStatus || PptGeneratingStatus) && i > 8)
              return null;
            return (
              <div
                className={
                  isshowSideBar || mentionPage || dashboard || !isPreviewState
                    ? "col-12 col-md-4 pr-0"
                    : isPreviewState
                    ? "col-12 col-md-6 pr-0"
                    : "col-12 col-md-4 pr-0"
                }
              >
                <div className="card cardList border-0 text-left mb-15">
                  <div
                    className="cardList-head pb-0 p-15 mt-0 card-head text_heading d-flex align-items-top"
                    style={{ height: "auto" }}
                  >
                    <div
                      className="position-relative mr-15"
                      style={{ width: "3.5rem", height: "3.5rem" }}
                    >
                      <Image
                        src={
                          el?.ProfilePicture === 0 ||
                          el?.ProfilePicture === "" ||
                          !el?.ProfilePicture
                            ? Profile
                            : el?.ProfilePicture
                        }
                        fallback={Profile}
                        preview={false}
                        alt="Profile Images"
                        className="profileImg mr-0 cursor-pointer"
                        style={{ width: "3.5rem" }}
                      />
                      <div
                        className="position-absolute"
                        style={{ right: "-0.8rem", top: "-0.4rem" }}
                      >
                        <img
                          src={
                            el?.ChannelGroupId === 0
                              ? Default_Brand
                              : SocialMedialogo?.[el?.ChannelGroupId]
                              ? SocialMedialogo?.[el?.ChannelGroupId]
                              : Default_Brand
                          }
                          style={{
                            width: "1.6rem",
                            maxHeight: "2rem",
                            verticalAlign: "top",
                          }}
                          alt="channel icon"
                        />
                      </div>
                    </div>
                    <div style={{ width: "calc(100% - 11.4rem)" }}>
                      <div
                        className="profileName line-height-normal d-flex align-items-center"
                        //style={{ maxWidth: "calc(100% - 6.5rem)" }}
                      >
                        <Tooltip title={el?.AuthorName}>
                          <span className="text-ellipsis">
                            {el?.AuthorName}
                          </span>
                        </Tooltip>

                        {el?.AuthorIsVerified !== "NA" &&
                        el?.AuthorIsVerified &&
                        el?.AuthorIsVerified > 0 ? (
                          <img
                            src={verified}
                            alt="verified"
                            className="profileImg ml-1"
                            style={{ width: "1.5rem" }}
                          />
                        ) : (
                          ""
                        )}
                      </div>

                      <div
                        className="screenName"
                        //style={{ maxWidth: "50%" }}
                      >
                        {el?.AuthorScreenName ? "(" : ""}
                        {el?.AuthorScreenName}
                        {el?.AuthorScreenName ? ")" : ""}
                      </div>
                    </div>
                    <div
                      className={`sentimentType ${
                        el?.SentimentType === "1"
                          ? "positive"
                          : el?.SentimentType === "2"
                          ? "negative"
                          : "neutral"
                      }`}
                    >
                      {el?.UserSentiment === "1"
                        ? "Positive"
                        : el?.UserSentiment === "2"
                        ? "Negative"
                        : "Neutral"}
                    </div>
                  </div>
                  <div
                    className={`card-body p-0 border-0 mt-0 ${
                      !el?.AuthorBio
                        ? "d-flex justify-content-center align-items-center"
                        : ""
                    }`}
                  >
                    <div
                      className="cardList__body-description fontSize-12 pl-15 pr-15"
                      style={{ minHeight: !el?.AuthorBio ? "inherit" : "" }}
                    >
                      {el?.AuthorBio ? (
                        <div className="text_regular font-weight500 w-100 mt-1">
                          Bio
                        </div>
                      ) : (
                        ""
                      )}

                      {el?.AuthorBio ? (
                        <div
                          className={`text_regular break-word w-100 ${textDirectionClass}`}
                        >
                          <a
                            className={
                              el?.AuthorURL && el?.AuthorURL !== "NA"
                                ? ""
                                : "pointer-events1 cursor-default"
                            }
                            href={
                              el?.AuthorURL && el?.AuthorURL !== "NA"
                                ? el?.AuthorURL
                                : ""
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            {el?.AuthorBio}
                          </a>
                        </div>
                      ) : (
                        <div className="text-grayLight fontSize-14 d-flex justify-content-center align-items-center pt-15 pb-15 w-100">
                          Bio not found
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="ner-attributes-section">
                    {/* For Hobbies */}
                    {el?.ner_hobbies?.length ? (
                      <div className="ner-attribute">
                        <div className="text_regular font-weight500">
                          Hobbies
                        </div>
                        <PillContainer pills={el?.ner_hobbies} />
                      </div>
                    ) : (
                      ""
                    )}
                    {/* For Nationality */}
                    {el?.ner_nationality?.length ? (
                      <div className="ner-attribute">
                        <div className="text_regular font-weight500">
                          Nationality
                        </div>
                        <PillContainer pills={el?.ner_nationality} />
                      </div>
                    ) : (
                      ""
                    )}
                    {/* For Occupation */}
                    {el?.ner_occupation?.length ? (
                      <div className="ner-attribute">
                        <div className="text_regular font-weight500">
                          Occupation
                        </div>
                        <PillContainer pills={el?.ner_occupation} />
                      </div>
                    ) : (
                      ""
                    )}
                    {/* For Organisation */}
                    {el?.ner_organisation?.length ? (
                      <div className="ner-attribute">
                        <div className="text_regular font-weight500">
                          Organisation
                        </div>
                        <PillContainer pills={el?.ner_organisation} />
                      </div>
                    ) : (
                      ""
                    )}
                    {/* For Religion */}
                    {el?.ner_religion?.length ? (
                      <div className="ner-attribute">
                        <div className="text_regular font-weight500">
                          Religion
                        </div>
                        <PillContainer pills={el?.ner_religion} />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="pl-15 pr-15 mt-1 mb-15 d-flex align-items-center flex-wrap">
                    <span className="mr-15 d-flex align-items-center flex-wrap">
                      <img
                        src={FollowersBlue}
                        className="cardList__footer-label"
                        alt="Followers"
                      />
                      <span className="text-grayLight ml-1 mr-1 fontSize-12">
                        Followers
                      </span>
                      <Tooltip title={el?.Followers?.toLocaleString()}>
                        <span className="cardList__footer-count font-weight600 blue-text fontSize-12">
                          {kFormatter(el?.Followers)}
                        </span>
                      </Tooltip>
                    </span>
                    <span className="mr-15 d-flex align-items-center flex-wrap">
                      <img
                        src={FollowingBlue}
                        className="cardList__footer-label"
                        alt="FollowingBlue"
                      />
                      <span className="text-grayLight ml-1 mr-1 fontSize-12">
                        Following
                      </span>
                      <Tooltip title={el?.Following?.toLocaleString()}>
                        <span className="cardList__footer-count font-weight600 blue-text fontSize-12">
                          {kFormatter(el?.Following)}
                        </span>
                      </Tooltip>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
          {/* </StackGrid> */}
        </div>
      ) : (
        <div
          className="d-flex align-items-center justify-content-center w-100"
          style={{ minHeight: "calc(100vh - 21.3rem)" }}
        >
          <div className="text-center">
            <img
              alt="no data"
              src={somethingWentWrong}
              style={{ maxWidth: "100%", minWidth: "20rem" }}
            />
            <p className="mt-15 text_regular-gray">No Data Found</p>
          </div>
        </div>
      )}

      <PaginationComponent
        data={data}
        totalPageNo={totalPageNo}
        metadata={metadata}
        section_index={section_index}
        widget_index={widget_index}
        mentionPage={mentionPage}
        pagination={pagination}
        isPreviewState={isPreviewState}
        dashboard={dashboard}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        chart_type={chart_type}
      />
    </>
  );
};

export default React.memo(AuthorCard, isEqual);
